module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKIEGED.4b567788.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKIEGED.png
// module id = 66
// module chunks = 0